'use client';

import type { ProductDisplayData as Product } from '@eliadmin/core/src/api/products/types/product-types';

import { ProductTile } from '@eliadmin/core/src/components/dlz/product/product-tile';

export type ProductCardProps = {
  product: Product;
  /** Native lazy-image sizing follows the rendered slot; older browsers use 300px. */
  imageSizes?: string;
  className?: {
    main?: string;
  };
};

/** Core override – every core product grid and carousel renders the DLZ „Product card“. */
export function ProductCard({ product, imageSizes, className }: ProductCardProps) {
  return <ProductTile product={product} imageSizes={imageSizes} className={className?.main} />;
}
